/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */


/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';
import { TextControl, BlockControls, ToolbarGroup, AlignmentToolbar } from '@wordpress/components';
import { useBlockProps, RichText } from '@wordpress/block-editor';
import SearchIcon from './search.svg';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */
export default function Edit({ className, attributes: attr, setAttributes }) {    
	const onChangeContent = ( newContent ) => {
        setAttributes( { content: newContent } );
    };

    const onChangeAlignment = ( newAlignment ) => {
        setAttributes( {
            alignment: newAlignment === undefined ? 'none' : newAlignment,
        } );
    };
	return (
		<div { ...useBlockProps() }>
			{/* <BlockControls>
                <ToolbarGroup>
                    <AlignmentToolbar
                        value={ attr.alignment }
                        onChange={ onChangeAlignment }
                    />
                </ToolbarGroup>
            </BlockControls> */}

            {/* <RichText
                className={ className }
                style={ { textAlign: attr.alignment } }
                tagName="p"
                onChange={ onChangeContent }
                value={ attr.content }
            /> */}

			{/* { __(
				'Pixfort Search – hello from the editor testing!',
				'pix-small-search'
			) }
			<TextControl
                placeholder={__('Search...', 'my-plugin')}
                disabled
            /> */}
			<div className="pix-small-search pix-ajax-search-container position-relative bg-white shadow-sm rounded-lg pix-small-search" method="get" action="">
				<div className="d-flex">
					<input type="search" className="form-control pix-ajax-search form-control-lg shadow-0 font-weight-bold text-body-default" name="s" autocomplete="off" placeholder="Search for something" aria-label="Search" />
					<button className="btn btn-search btn-white m-0 text-body-default" aria-label="Search" type="submit"><img src={SearchIcon} /></button>
				</div>
			</div>
		</div>
	);
}
